// eslint-disable-next-line
import { Parser, Builder } from 'xml2js';

export const xmlToJson = (xmlString, options) => {
  let json = {};
  const parser = new Parser(options);
  parser.parseString(xmlString, (err, result) => {
    json = result;
  });
  return json;
};

export const jsonToXml = (json, options) => {
  const builder = new Builder(options);
  return builder.buildObject(json);
};

export const getElementValue = (element) => {
  if (element && element instanceof Array) {
    return element[0];
  }
  return element;
};



// WEBPACK FOOTER //
// ./app/util/xmlUtils.js